var map = {
	"./Adelaide-Crows.jpg": "b4gq",
	"./Brisbane-Lions.jpg": "6kEQ",
	"./Carlton.jpg": "3Ie8",
	"./Collingwood.jpg": "3RT5",
	"./Essendon.jpg": "a9N2",
	"./Fremantle.jpg": "m9SP",
	"./GWS-Giants.jpg": "T7Ky",
	"./Geelong-Cats.jpg": "OeJ9",
	"./Gold-Coast-Suns.jpg": "HHN5",
	"./Hawthorn.jpg": "zuNq",
	"./Melbourne.jpg": "egDi",
	"./North-Melbourne.jpg": "qlci",
	"./Port-Adelaide.jpg": "mh08",
	"./Richmond.jpg": "Rldu",
	"./St-Kilda.jpg": "W/HL",
	"./Sydney-Swans.jpg": "9hh6",
	"./West-Coast-Eagles.jpg": "LoDH",
	"./Western-Bulldogs.jpg": "kofC",
	"./header.jpg": "Y5I1",
	"./x-x.jpg": "p5P7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53WL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.jpg$
// module id = 53WL
// module chunks = 1